import React, { Component } from "react";
import CreateArticleForm from "./create/create-article.component";
import { Navigate, Route, Routes } from "react-router-dom";
import EditArticleComponent from "./update/edit-article.component";
import { TypedConnect } from "models/store";

@TypedConnect(
  () => {
    return {};
  },
  () => {
    return {};
  }
)
export default class ArticlePanelComponent extends Component {
  render() {
    /** TODO: auth guards for CreateArticleForm, edit, and delete components */
    return (
      <div>
        <Routes>
          <Route path="create" element={<CreateArticleForm />}></Route>
          {/* The former route had no article identifier, so it cannot be a
              reliable permalink. Keep it as a safe landing for old links. */}
          <Route path="show" element={<Navigate to="/" replace />}></Route>
          <Route path="edit/:articleID/:slug?" element={<EditArticleComponent />}></Route>
          {/* TODO: delete */}
        </Routes>
      </div>
    );
  }
}
